/*eslint-disable*/
/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
/*eslint-enable*/
import router from "@/router";
import { setApplicationLocalStorageItem } from "../../helpers";
import store from "../store";
import { performFetch } from '../../helpers.js'

export default {
  async updateDashboardLayout({ state }, payload) {
    payload.screen_size = store.state.dashboardAnalytics.screenSize;

    return new Promise(async (resolve, reject) => {
      // await fetch(`${store.state.auth.api_url}`, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "set_dashboard_data",
      //     parameters: {
      //       application_token: store.state.auth.app_token,
      //       session_token: store.state.auth.token,
      //       dashboard: payload
      //     }
      //   })
      // })
      await performFetch(`${store.state.auth.api_url}`, {
        command: "set_dashboard_data",
        parameters: {
          application_token: store.state.auth.app_token,
          session_token: store.state.auth.token,
          dashboard: payload
        }
      })
        .then(async response => {
          if (response.status === 200) {
            await store.dispatch("dashboardAnalytics/setDashboardLabels", {
              dashboardHash: payload.hash
            });

            resolve(true);
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            store.dispatch("auth/signOut");
          }
        })
        .catch(e => {
          throw new Error(e.message);
        });
    });
  },
  async setDashboardLabels({ state }, payload) {
    payload.labels = store.state.dashboardAnalytics.labelData;

    return new Promise(async (resolve, reject) => {
      // await fetch(`${store.state.auth.api_url}`, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "set_dashboard_card_labels",
      //     parameters: {
      //       application_token: store.state.auth.app_token,
      //       session_token: store.state.auth.token,
      //       dashboard_hash: payload.dashboardHash,
      //       labels: payload.labels
      //     }
      //   })
      // })
      await performFetch(`${store.state.auth.api_url}`, {
        command: "set_dashboard_card_labels",
        parameters: {
          application_token: store.state.auth.app_token,
          session_token: store.state.auth.token,
          dashboard_hash: payload.dashboardHash,
          labels: payload.labels
        }
      })
        .then(async response => {
          if (response.status === 200) {
            resolve(true);
          } else if (response.status == 401) {
            setApplicationLocalStorageItem(
              "lastUrl",
              btoa(window.location.pathname)
            );
            store.dispatch("auth/signOut");
          }
        })
        .catch(e => {
          throw new Error(e.message);
        });
    });
  }
};
